import * as React from 'react';

export const RowMenuContainer = (props: React.PropsWithChildren<{ className?: string }>) =>
    <div className={`menu-container font-14 ${props.className || ''}`}>
        {props.children}
    </div>;
